import { ICorrection, IMeetingSession } from '@turing/interfaces/event';

interface IEventState {
  loading: boolean;
  overdueEvents: ICorrection[];
  todaysEvents: Array<IMeetingSession | ICorrection>;
  tomorrowsEvents: Array<IMeetingSession | ICorrection>;
  liveEvents: Array<IMeetingSession | ICorrection>;
  showSchedule: boolean;
  selectedEvent: IMeetingSession | ICorrection | null;
}

const ManageEventAction: string = 'Events';

export default IEventState;
export { ManageEventAction };
